import React, { useContext } from 'react';
import { AddStorageDataContext } from 'context/AddStorageContext';
import styled from 'styled-components';
const CDN_URL = process.env.REACT_APP_CDN_URL;

const PublicIconDefault = `${CDN_URL}storage/Storage-public-icon-default.svg`;
const PublicIconHover = `${CDN_URL}storage/Storage-public-icon-hover.svg`;
const PublicIconSelected = `${CDN_URL}storage/Storage-public-icon-selected.svg`;
const PrivateIconDefault = `${CDN_URL}storage/Storage-private-icon-default.svg`;
const PrivateIconHover = `${CDN_URL}storage/Storage-private-icon-hover.svg`;
const PrivateIconSelected = `${CDN_URL}storage/Storage-private-icon-selected.svg`;

const ShareAccessStyle = styled.div`
	display: flex;
	justify-content: center;
	.accessibility-selection {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		margin: 10px;
		img {
			cursor: pointer;
			width: 50px;
			height: 50px;
			margin-top: 10px;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		.accessibility-selection {
			margin: 10px;
			img {
				width: 75px;
				height: 75px;
				margin-top: 15px;
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		.accessibility-selection {
			margin: 10px;
			img {
				width: 100px;
				height: 100px;
				margin-top: 25px;
			}
		}
	}
`;

export const ShareAccessScreen = () => {
	const { inputs, change } = useContext(AddStorageDataContext);

	const selected = inputs?.access;
	const publicIcon = selected === 'public' ? PublicIconSelected : PublicIconDefault;
	const privateIcon = selected === 'private' ? PrivateIconSelected : PrivateIconDefault;

	return (
		<ShareAccessStyle>
			<div className={`accessibility-selection private`}>
				<div className='form-dropdown-selection body10'>PRIVATE</div>
				<img
					src={privateIcon}
					onMouseEnter={e =>
						(e.currentTarget.src = selected === 'private' ? privateIcon : PrivateIconHover)
					}
					onMouseLeave={e => (e.currentTarget.src = privateIcon)}
					onClick={() => change({ target: { name: 'access', value: 'private' } })}
					data-cy='private'
				/>
			</div>
			<div className={`accessibility-selection public`}>
				<div className='form-dropdown-selection body10'>PUBLIC</div>
				<img
					src={publicIcon}
					onMouseEnter={e =>
						(e.currentTarget.src = selected === 'public' ? publicIcon : PublicIconHover)
					}
					onMouseLeave={e => (e.currentTarget.src = publicIcon)}
					onClick={() => change({ target: { name: 'access', value: 'public' } })}
					data-cy='public'
				/>
			</div>
		</ShareAccessStyle>
	);
};
